module.exports = __webpack_public_path__ + "static/media/lateral-flexion.f71d1c55.png";